/**
 * nodeTeaser
 */

// Module dependencies
import 'protons';

// Module styles
import './_node-teaser-grid.scss';

// Module template
import './_node-teaser-grid.twig';

export const name = 'nodeTeaser';

export const defaults = {
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { nodeTeaser = {} }) {
  // This code checks if the teaser is visible for mobile devices
  // Check if IntersectionObserver is supported by browser
  if (('IntersectionObserver' in window) ||
    ('IntersectionObserverEntry' in window) ||
    ('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1
    }
    // Define function to be ran by observer, and add classes if visible or not
    function toggleClass(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.intersectionRatio >= 1) {
          entry.target.classList.add('visible');
        } else {
          entry.target.classList.remove('visible');
        }
      });
    }
    // Create observer object and query for node teasers
    const observer = new IntersectionObserver(toggleClass, options);
    const nodeTeasers = [...document.querySelectorAll('.node-teaser-grid')];

    // If window width is laptop, observe each teaser
    if (nodeTeasers.length && window.innerWidth <= 1024) {
      nodeTeasers.forEach(teaser => {
        observer.observe(teaser);
      });
    }
  }
}

export default enable;
